exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-1b2cfd7a&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Comment.vue
// module id = 349
// module chunks = 0